import { render } from "./SelectImages.vue?vue&type=template&id=3c372e05&scoped=true"
import script from "./SelectImages.vue?vue&type=script&lang=js"
export * from "./SelectImages.vue?vue&type=script&lang=js"

import "./SelectImages.vue?vue&type=style&index=0&id=3c372e05&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c372e05"]])

export default __exports__